import { render, staticRenderFns } from "./Phase1Section3Form.vue?vue&type=template&id=74192341&scoped=true&"
import script from "./Phase1Section3Form.vue?vue&type=script&lang=js&"
export * from "./Phase1Section3Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74192341",
  null
  
)

/* custom blocks */
import block0 from "./Phase1Section3Form.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports